import React from 'react'

import { DeclineTemplate } from '@components/BonusSystemCommon'
import { buildAtlasImageStyles } from '@utils/buildAtlasImageStyles'
import { useBuyBonusStore } from '@stores/buyBonusStore'
import { useFreeBuyBonusStore } from '@stores/freeBuyBonusStore'
import { DeclineBonusInfo, DeclineBonusStyles } from '@components/BonusSystemCommon/content/DeclineTemplate'
import { Bonus } from 'game-ui-types'
import { useTranslation } from '@amusnet/translations/react'
import { useLoadAtlasesWhenGameSettingsReady } from '@hooks'
import { getBuyBonusAtlasPaths } from '@utils/gameSettings'
import { resolveFreeBuyBonusImage } from '@utils/bonus'

interface FBBDeclineProps {
    bonus?: Bonus
}

const FBBDecline: React.FC<FBBDeclineProps> = ({ bonus }) => {
    const findElementByImageName = useBuyBonusStore((state) => state.findElementByImageName)
    const atlasMap = useBuyBonusStore((state) => state.atlasMap)
    const cachedImages = useBuyBonusStore((state) => state.cachedImages)
    const loadAtlasesFromPath = useBuyBonusStore((state) => state.loadAtlasesFromPath)

    const styles = useFreeBuyBonusStore((state) => state.styles)

    const { t } = useTranslation()

    useLoadAtlasesWhenGameSettingsReady(getBuyBonusAtlasPaths, loadAtlasesFromPath)

    const freeBonusNameText = t('gameui.bonusSystem.freeBonusName', {
        bonusName: bonus?.typeConfiguration?.freeBuyBonusConfiguration?.label ?? '',
    })

    const bonusInfo: DeclineBonusInfo | undefined = bonus && {
        betValue: bonus.betValue,
        bundleDetails: [
            {
                text: freeBonusNameText,
                styles: 'text-4xl font-black leading-[2.2]',
            },
        ],
    }

    const image =
        atlasMap && bonus
            ? resolveFreeBuyBonusImage(
                  findElementByImageName,
                  bonus.typeConfiguration?.freeBuyBonusConfiguration?.imageName
              )
            : undefined
    const stylesConfig: DeclineBonusStyles = {
        primaryTextColor: styles.primaryTextColor,
        secondaryTextColor: styles.secondaryTextColor,
        background: styles.bodyBackground,
        imageStyles: image
            ? buildAtlasImageStyles(image.atlasName, image.value, cachedImages[image.atlasName])
            : undefined,
    }

    return <DeclineTemplate bonusInfo={bonusInfo} styles={stylesConfig} />
}

export default FBBDecline
